import { Profile } from "@/types/supabase";
import CodeEditor from "./CodeEditor";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { atomDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { useIsMobile } from "@/hooks/use-mobile";

const ProfileJson = ({ profile }: { profile: Profile }) => {
  const isMobile = useIsMobile();

  return (
    <CodeEditor>
      <div className="space-y-1">
        <SyntaxHighlighter
          language="csharp"
          style={atomDark}
          customStyle={{
            borderRadius: "0rem",
            padding: "0rem",
            fontSize: isMobile ? "0.5rem" : "0.8rem",
            background: "#00000000",
            margin: "0rem",
            overflow: "clip",
          }}
        >
          {profile?.profile_json}
        </SyntaxHighlighter>
      </div>
    </CodeEditor>
  );
};

export default ProfileJson;
